import { AuthButtonBar } from "components/Auth/AuthButtonBar";
import { AuthUIWrapper } from "components/Auth/AuthUIWrapper";
import { GoogleAuth } from "components/design/authWithGoogle";
import Async from "components/DesignSystem/AsyncComponents/Async";
import { usePageTitle } from "hooks/usePageTitle";
import { useUserOnboardingStepper } from "hooks/useUserOnboardingStepper";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useGetCrmUserQuery } from "store/apis/onboarding";

export const PhoneVerify = () => {
  usePageTitle("Phone verify");
  const { hash } = useLocation();
  const crmAccessToken = hash?.split("#payload=")[1];
  const { data, isLoading, isError } = useGetCrmUserQuery(
    { crmAccessToken },
    { skip: crmAccessToken === undefined }
  );
  const { canMoveNext, goNext, goBack } = useUserOnboardingStepper();
  const [askPhoneNumber, setAskPhoneNumber] = useState(true);
  const history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem("magicLinkData")) {
      history.replace("/signin");
    }
  }, []);

  useEffect(() => {
    if (isError) {
      history.push("/signin");
    }
  }, [isError]);

  useEffect(() => {
    if (data) {
      localStorage.setItem("magicLinkData", JSON.stringify(data));
    }
    if (data?.type) {
      localStorage.setItem("user_type", data.type);
    }
  }, [data]);

  const handleGoBack = () => {
    if (!askPhoneNumber) {
      setAskPhoneNumber(true);
    } else {
      goBack();
    }
  };

  return (
    <Async.Root isSuccess={!isLoading} isLoading={isLoading} isEmpty={false}>
      <Async.Empty>
        <></>
      </Async.Empty>
      <Async.Success>
        <AuthUIWrapper
          buttonBar={
            <AuthButtonBar
              nextDisabled={!canMoveNext}
              onNext={goNext}
              onBack={handleGoBack}
            />
          }
          isPhoneVerify
        >
          <div className="t-mt-[72px] sm:t-mt-8">
            <GoogleAuth
              googleAccessToken={undefined}
              setLoading={undefined}
              onGoogleAuthFail={undefined}
              askPhoneNumber={askPhoneNumber}
              setAskPhoneNumber={setAskPhoneNumber}
              viewOnly={canMoveNext}
            />
          </div>
        </AuthUIWrapper>
      </Async.Success>
    </Async.Root>
  );
};
